import { UAParser } from 'ua-parser-js'

class Detect {
  constructor() {
    this.breakpoints = {
      sp: 320,
      tb: 768,
      pc: 960,
    }
    this.parser = new UAParser()
    this.result = this.parser.getResult()
  }

  static getInstance() {
    if (this.instance) {
      return this.instance
    }
    this.instance = new Detect()
    return this.instance
  }

  getBrowserName() {
    return this.result.browser.name
  }

  getDeviceType() {
    let type = this.result.device.type
    if (!type) {
      type = this.isiPad() ? 'tablet' : type
    }
    return type
  }

  isIE() {
    return this.result.browser.name === 'IE'
  }

  isIE11() {
    return (
      this.result.browser.name === 'IE' && this.result.browser.version === '11'
    )
  }

  isEdge() {
    return this.result.browser.name === 'Edge'
  }

  isSafari() {
    return this.result.browser.name === 'Safari'
  }

  isiPad() {
    // Macintosとontouchendは判定が重要です
    return /iPad|Macintosh/i.test(this.result.ua) && 'ontouchend' in document
  }

  isPc() {
    return !this.isTablet() && !this.isMobile()
  }

  isTablet() {
    // ipadのosがipadosになり、ua-parser-js対応してないためthis.isiPad()を追加
    return this.result.device.type === 'tablet' || this.isiPad()
  }

  isMobile() {
    return this.result.device.type === 'mobile'
  }

  lessThanSp() {
    return window.innerWidth < this.breakpoints.sp
  }

  moreThanSp() {
    return window.innerWidth >= this.breakpoints.sp
  }

  lessThanTb() {
    return window.innerWidth < this.breakpoints.tb
  }

  moreThanTb() {
    return window.innerWidth >= this.breakpoints.tb
  }

  lessThanPc() {
    return window.innerWidth < this.breakpoints.pc
  }

  moreThanPc() {
    return window.innerWidth >= this.breakpoints.pc
  }

  isUnsupported() {
    if (
      this.result.browser.name === 'IE' &&
      this.result.browser.version &&
      this.result.browser.version <= '10'
    ) {
      return true
    }

    return false
  }
}

export default Detect